import { LineStyle, LineType } from 'lightweight-charts';
export const chartOptions = {
    layout: {
        background: { color: '#002417' },
        textColor: '#87cca2',
        attributionLogo: false
    },
    grid: {
        vertLines: { visible: false },
        horzLines: { visible: false }
    },
    rightPriceScale: {
        visible: true,
        entireTextOnly: true,
        ticksVisible: true,
        minimumWidth: 60,
        alignLabels: true,
        borderVisible: false,
        scaleMargins: { top: 0.2, bottom: 0.12 }
    },
    leftPriceScale: {
        visible: false
    },
    timeScale: {
        borderVisible: false,
        timeVisible: true,
        secondsVisible: true,
        rightOffset: 6,
        barSpacing: 8,
        lockVisibleTimeRangeOnResize: true,
        rightBarStaysOnScroll: true
    },
    crosshair: {
        vertLine: {
            color: 'rgba(132, 249, 164, 0.45)',
            width: 1,
            style: LineStyle.Solid,
            labelBackgroundColor: '#0b3b28'
        },
        horzLine: {
            color: 'rgba(132, 249, 164, 0.45)',
            width: 1,
            style: LineStyle.Solid,
            labelBackgroundColor: '#0b3b28'
        }
    },
    handleScroll: {
        mouseWheel: true,
        pressedMouseMove: true
    },
    handleScale: {
        pinch: true,
        axisPressedMouseMove: true,
        mouseWheel: true
    }
};
export const areaSeriesOptions = {
    lineColor: '#00c076',
    lineWidth: 2,
    lineType: LineType.Curved,
    topColor: 'rgba(0, 192, 118, 0.38)',
    bottomColor: 'rgba(0, 192, 118, 0.01)',
    lastValueVisible: true,
    priceLineVisible: true,
    crosshairMarkerVisible: true,
    crosshairMarkerRadius: 5,
    crosshairMarkerBorderColor: '#00c076',
    crosshairMarkerBackgroundColor: '#0f141d'
};
export const candleSeriesOptions = {
    upColor: '#00c076',
    downColor: '#f6465d',
    wickUpColor: '#00c076',
    wickDownColor: '#f6465d',
    borderUpColor: '#00c076',
    borderDownColor: '#f6465d',
    lastValueVisible: true,
    priceLineVisible: true
};
